import styled from 'styled-components';
import { FontSize } from '../../assets/font';
import { Typography } from '@mui/material';

export const HeaderOne = styled(Typography)`
    && {
        font-size: ${FontSize.header1};
        font-weight: bold;
    }
`;